import "index.scss";
// Side-effect import: runs i18n.init() (backend, language detector,
// initReactI18next). Must happen at the app entry point — every t() call
// across the app depends on this having run, so it can't be left to ride
// along with whichever component happens to import from "i18n" (that's what
// broke it before: it was only reachable via LanguageSwitcher, and once that
// was left unrendered, a production build tree-shook this out entirely,
// leaving every t() call returning its raw hash key).
import "i18n";
import Store from "store";
import ReactDOM from "react-dom";
import Loader from "utils/Loader";
import React, { lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import reportWebVitals from "reportWebVitals";
import { createStore, StoreProvider } from "easy-peasy";
import { store } from "api/client";

const clientStore = store;
const LazyApp = lazy(() => import("App"));

const AppRoot = (
  <React.StrictMode>
    <StoreProvider store={clientStore}>
      <Suspense fallback={<Loader />}>
        <LazyApp />
      </Suspense>
    </StoreProvider>
  </React.StrictMode>
);

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(AppRoot);

// ReactDOM.render(AppRoot, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
